import { flagOptions } from 'helpers';
import { FlagType } from 'types';
export const flagTypeToLabel = (flagType?: FlagType) => {
  return (
    flagOptions.find((flag) => flag.value === flagType)?.label || 'Unknown Type'
  );
};
